/**
 * Presentation of the committed knowledge mappingSeed at fac3b658.
 * Source: docs/features/scenario-center/reference/synthetic/high-rise-building-fire/
 * knowledge/requirement-projection.v1.json, plus research-overlay.mjs.
 * The only named definition is HRF-CR-03 (water at height), outside the six-issue set.
 * Do not turn editorial topic keys into definition IDs or widen the existing reader gate.
 */
const unmappedRequirements = new Set([
  'HRF-CR-01',
  'HRF-CR-02',
  'HRF-CR-04',
  'HRF-CR-05',
  'HRF-CR-06',
  'HRF-CR-08',
  'HRF-CR-12',
  'HRF-CR-15',
  'HRF-CR-17',
  'HRF-CR-19',
]);
export function scenarioDefinitionAvailability(requirementId: string): {
  readonly status: 'UNMAPPED' | 'UNKNOWN';
  readonly message: string;
} {
  return unmappedRequirements.has(requirementId)
    ? {
        status: 'UNMAPPED',
        message:
          '能力定义暂不可查看：本项尚无经批准的正式能力 ID 映射，需由场景内容与能力定义 Owner 确认。',
      }
    : {
        status: 'UNKNOWN',
        message: '能力定义暂不可查看：精确定义及适用性尚未核实，当前无法建立可信关联。',
      };
}
